import { ADD_TEXT } from "../constants/action-types";

let initialState = {
  texts: [],
  meta: [],
  ssr: false
};

if (typeof window.preloadedInitialState !== 'undefined' && window.preloadedInitialState) {
  initialState = window.preloadedInitialState;
}

initialState['lastUrl'] = false;

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TEXT:
      return { ...state, texts: [...state.texts, action.newText] };
    default:
      return state;
  }
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js